module.exports = __webpack_public_path__ + "img/4.70a29132.jpg";